module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "bk"
    }
  }, [_c('h1', {
    staticClass: "bk"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piii"
    }
  }), _vm._v("DECOLONIZING THE MAP")]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_vm._v("CARTOGRAPHY FROM COLONY TO NATION")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("EDITED BY JAMES R. AKERMAN")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_vm._v("THE UNIVERSITY OF CHICAGO PRESS")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_vm._v("Chicago and London")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d9788c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-Akerman-0004.vue
// module id = 63
// module chunks = 0